import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const EL = '.js-history';

document.querySelectorAll('.js-history').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: true,
    fixedWidth: '400px',
    gap: 30,
    perPage: 3,
    breakpoints: {
      1366: {},
      1024: {},
      767: {
        fixedWidth: '300px',
        gap: 20,
      },
    },
  });

  slider.mount({ AutoScroll });

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');

  const updateControls = () => {
    if (prevButton) prevButton.disabled = false;
    if (nextButton) nextButton.disabled = false;
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  slider.on('moved', updateControls);
  updateControls();
});
